import { useState, useEffect } from 'react'
import { Table, Card, Tag, Button, Space, Modal, Form, Input, Select, Switch, message, Popconfirm } from 'antd'
import { NotificationOutlined, PlusOutlined } from '@ant-design/icons'
import axios from 'axios'

const Announcements = () => {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 })
  const [modalOpen, setModalOpen] = useState(false)
  const [form] = Form.useForm()
  const [readModalOpen, setReadModalOpen] = useState(false)
  const [readList, setReadList] = useState<any[]>([])

  const typeMap: Record<number, { label: string; color: string }> = {
    0: { label: '普通', color: 'default' },
    1: { label: '重要', color: 'orange' },
    2: { label: '紧急', color: 'red' },
  }

  const loadList = async (page = 1) => {
    setLoading(true)
    try {
      const res = await axios.get('/api/announcements', { params: { page, pageSize: pagination.pageSize } })
      if (res.data.code === 0) {
        setList(res.data.data.list)
        setPagination(prev => ({ ...prev, current: page, total: res.data.data.total }))
      }
    } catch (err) {
      message.error('加载公告失败')
    }
    setLoading(false)
  }

  useEffect(() => { loadList() }, [])

  const handleCreate = async () => {
    try {
      const values = await form.validateFields()
      const userStr = localStorage.getItem('user')
      const user = userStr ? JSON.parse(userStr) : {}
      const res = await axios.post('/api/announcements', {
        ...values,
        created_by: user.id || 1,
        is_pinned: values.is_pinned ? 1 : 0,
      })
      if (res.data.code === 0) {
        message.success('发布成功')
        setModalOpen(false)
        form.resetFields()
        loadList()
      }
    } catch (err) {
      message.error('发布失败')
    }
  }

  const handleViewReads = async (id: number) => {
    try {
      const res = await axios.get(`/api/announcements/${id}/read-status`)
      if (res.data.code === 0) {
        setReadList(res.data.data.reads)
        setReadModalOpen(true)
      }
    } catch (err) {
      message.error('加载已读情况失败')
    }
  }

  const columns = [
    {
      title: '标题',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      render: (type: number) => {
        const t = typeMap[type] || typeMap[0]
        return <Tag color={t.color}>{t.label}</Tag>
      },
    },
    {
      title: '置顶',
      dataIndex: 'is_pinned',
      key: 'is_pinned',
      render: (v: number) => v ? <Tag color="purple">置顶</Tag> : '-',
    },
    {
      title: '发布时间',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (v: string) => new Date(v).toLocaleString('zh-CN'),
    },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: any) => (
        <Space>
          <Button size="small" onClick={() => handleViewReads(record.id)}>已读情况</Button>
        </Space>
      ),
    },
  ]

  return (
    <>
      <Card title={<><NotificationOutlined /> 公告管理</>} extra={
        <Button type="primary" icon={<PlusOutlined />} onClick={() => setModalOpen(true)}>发布公告</Button>
      }>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={list}
          loading={loading}
          pagination={{
            ...pagination,
            onChange: (page) => loadList(page),
            showTotal: (total) => `共 ${total} 条`,
          }}
        />
      </Card>

      <Modal title="发布公告" open={modalOpen} onOk={handleCreate} onCancel={() => setModalOpen(false)} width={600}>
        <Form form={form} layout="vertical">
          <Form.Item name="title" label="标题" rules={[{ required: true, message: '请输入标题' }]}>
            <Input placeholder="公告标题" />
          </Form.Item>
          <Form.Item name="content" label="内容" rules={[{ required: true, message: '请输入内容' }]}>
            <Input.TextArea rows={6} placeholder="公告内容" />
          </Form.Item>
          <Space>
            <Form.Item name="type" label="类型" initialValue={0}>
              <Select style={{ width: 120 }}>
                <Select.Option value={0}>普通</Select.Option>
                <Select.Option value={1}>重要</Select.Option>
                <Select.Option value={2}>紧急</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name="is_pinned" label="置顶" valuePropName="checked" initialValue={false}>
              <Switch />
            </Form.Item>
          </Space>
        </Form>
      </Modal>

      <Modal title="已读情况" open={readModalOpen} onCancel={() => setReadModalOpen(false)} footer={null}>
        <p style={{ marginBottom: 12 }}>已读人数：{readList.length}</p>
        <Table
          rowKey="id"
          size="small"
          pagination={false}
          columns={[
            { title: '用户', dataIndex: ['reader', 'username'], render: (t: string, r: any) => t || r.reader?.phone },
            { title: '已读时间', dataIndex: 'read_at', render: (v: string) => new Date(v).toLocaleString('zh-CN') },
          ]}
          dataSource={readList}
        />
      </Modal>
    </>
  )
}

export default Announcements
